export default "__VITE_ASSET__84f866b5__"